import React from "react";
import { Link } from "react-router-dom";
import CreateTabs from "../../components/Tabs/CreateTabs";
import Expense from "../../components/Expense/Expense";

export default function Create() {
  return <Expense />;
}
